import { graphierQL } from 'utils'
import {
  UpdateMapSettingsMutation,
  UpdateMapSettingsMutationVariables,
  MapProperty,
  Map
} from '~map-settings/types/__generated/gql/graphql'
import { useMap, setMapData } from '~map-preview/states/map'
import { isEmpty } from 'lodash'
import { useDispatch } from 'react-redux'
import { toast } from 'ui-components'
import { useState } from 'react'

const useUpdateMapSettings = () => {
  const dispatch = useDispatch()
  const map = useMap()
  const [previousMap, setPreviousMap] = useState<Map | null>(null)

  return async (properties: MapProperty[]) => {
    try {
      const input = {
        id: map.id,
        properties: properties.map((property) => {
          const { id, options, classBreaks, ...rest } =
            property as MapProperty & { id: string }

          if (!isEmpty(options)) rest['options'] = options

          if (!isEmpty(classBreaks)) rest['classBreaks'] = classBreaks

          return rest
        })
      }
      setPreviousMap(map)

      dispatch(setMapData({ ...map, properties: input.properties }))

      await updateMapSettings({ input })
    } catch (error) {
      previousMap && dispatch(setMapData(previousMap))
      toast('Update failed')
    }
  }
}

const updateMapSettingsMutation = /* GraphQL */ `
  mutation UpdateMapSettings($input: UpdateMapSettingInput!) {
    updateMapSettings(input: $input) {
      id
      properties {
        name
        type
        isTitle
        options {
          fieldType
          format
        }
      }
    }
  }
`

const updateMapSettings = async (variables) =>
  await graphierQL<
    UpdateMapSettingsMutation,
    UpdateMapSettingsMutationVariables
  >({
    useToken: true,
    query: updateMapSettingsMutation,
    variables
  })

export { useUpdateMapSettings }
